import React, { useState, useEffect } from "react";
import "./index.scss";
import SiTable from "../../core/table";
import { getHeaderConfig } from "./config";
import CustomModal from "../../core/modal";
import { invokeApi, HTTP_METHODS } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { getOfflineData } from "../../utils/offline-services";
import { Add, ArrowForward } from "@mui/icons-material";
import CustomButtonComponent from "../../core/custom-button";
import CustomTable from "../../core/custom-table";
import ActionFilters from "./action-filters";
import { PAGE_LIMIT } from "../../utils";
const Actions = () => {
  const navigate = useNavigate();
  const [actions, setActions] = useState({
    results: [],
  });
  const [addAction, setAddAction] = useState(false);
  const [mainFilters, setMainFilters] = useState({});
  const [code, setCode] = useState("");
  const [description, setDescription] = useState("");
  const [filters, setFilters] = useState({
    type: "action",
    page: 1,
    limit: PAGE_LIMIT,
    sortBy: "-createdAt",
  });

  useEffect(() => {
    if (!getOfflineData("user")) {
      navigate("/");
    } else {
      loadData(filters);
    }
  }, []);
  const addActionFormHandler = () => {
    setAddAction(true);
  };
  const addCodeHandler = (event) => {
    setCode(event.target.value);
  };
  const addDescriptionHandler = (event) => {
    setDescription(event.target.value);
  };
  const payload = {
    type: "action",
    code: code,
    description: description,
  };
  //Add New Action
  const formSubmitHandler = () => {
    if (payload.code !== "" && payload.description !== "") {
      invokeApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.CODES}action`,
        payload,
        { active: true }
      )
        .then((response) => {
          if (response.message) {
            toast.error(response.message);
          } else {
            loadData(filters);
            setCode("");
            setDescription("");
            setAddAction(false);
          }
        })
        .catch((err) => console.error(err));
    }
  };
  //Show All Actions
  const loadData = (filters) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.List_CODES}`,
      null,
      filters
    )
      .then((response) => {
        if (response) {
          setActions(response);
        }
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    if (actions?.totalPages !== 0 && actions?.totalPages < actions?.page) {
      setFilters({ ...filters, page: 1 });
      loadData({
        ...filters,
        ...mainFilters,
        page: 1,
      });
    }
  }, [actions]);
  return (
    <div className="page-body">
      <div className="create-con">
        <div>
          <p className="tab-name">Setup</p>
          <p className="section-name">Action Codes</p>
        </div>
        <CustomButtonComponent
          variant="contained"
          color="primary"
          onClick={addActionFormHandler}
        >
          Add Action Code
        </CustomButtonComponent>
      </div>

      <div className="si-hide-mobile">
        <CustomTable
          header={getHeaderConfig(loadData, filters)}
          data={actions.results || []}
          pageCount={actions.totalPages}
          filters={filters}
          onChange={(page) => {
            setFilters({
              ...filters,
              page,
            });
            loadData({
              ...filters,
              ...mainFilters,
              page,
            });
          }}
          filterCom={
            <ActionFilters
              loadData={loadData}
              setMainFilters={setMainFilters}
              filter={filters}
            />
          }
        />
      </div>
      {addAction && (
        <CustomModal
          title="New Action Code"
          onClose={() => {
            setAddAction(false);
          }}
        >
          <Box
            sx={{
              width: 500,
              maxWidth: "100%",
            }}
          >
            <TextField
              fullWidth
              id="code"
              label="Code"
              sx={{ m: 1 }}
              onChange={addCodeHandler}
              value={code}
              size="small"
            />
            <TextField
              fullWidth
              id="description"
              label="Description"
              multiline
              sx={{ m: 1 }}
              rows={4}
              onChange={addDescriptionHandler}
              value={description}
              size="small"
            />
            <Stack
              direction="row"
              spacing={2}
              sx={{ m: 1, justifyContent: "flex-end" }}
            >
              <CustomButtonComponent
                variant="outlined"
                color="error"
                onClick={() => {
                  setAddAction(false);
                }}
              >
                Cancel
              </CustomButtonComponent>
              <CustomButtonComponent
                variant="contained"
                color="primary"
                onClick={formSubmitHandler}
              >
                Save
              </CustomButtonComponent>
            </Stack>
          </Box>
        </CustomModal>
      )}
    </div>
  );
};

export default Actions;
